export { CovidShieldIcon } from "./covid-shield";
